module.exports = __webpack_public_path__ + "static/img/banner1-4.a9857b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202305/banner1-4.jpg
// module id = LR/A
// module chunks = 0